import { motion } from 'framer-motion'
import { useEffect } from 'react'
import styled from 'styled-components'
import { useResponsive } from '../../hooks/useResponsive'

const IntroContainer = styled(motion.div)`
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 9999;
    overflow: hidden;
    background: #0a0a0a;
    display: flex;
    justify-content: center;
    align-items: center;
`

const ContentWrapper = styled(motion.div)`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${props => props.isMobile ? '24px' : '32px'};
`

const LogoMark = styled(motion.div)`
    width: ${props => props.isMobile ? '60px' : '80px'};
    height: ${props => props.isMobile ? '60px' : '80px'};
    border: 2px solid rgba(255, 255, 255, 0.9);
    border-radius: 50%;
    position: relative;
    
    /* 内圈 */
    &::before {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 60%;
        height: 60%;
        border: 1px solid rgba(255, 255, 255, 0.5);
        border-radius: 50%;
    }
    
    /* 中心点 */
    &::after {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 8px;
        height: 8px;
        background: #fff;
        border-radius: 50%;
    }
`

const MainTitle = styled(motion.h1)`
    font-size: ${props => props.isMobile ? '1.8rem' : '2.8rem'};
    font-weight: 200;
    color: #ffffff;
    letter-spacing: ${props => props.isMobile ? '6px' : '12px'};
    margin: 0;
    font-family: 'Times New Roman', Georgia, serif;
    text-transform: uppercase;
`

const Divider = styled(motion.div)`
    width: ${props => props.isMobile ? '40px' : '60px'};
    height: 1px;
    background: rgba(255, 255, 255, 0.4);
`

const Subtitle = styled(motion.p)`
    font-size: ${props => props.isMobile ? '0.7rem' : '0.85rem'};
    color: rgba(255, 255, 255, 0.6);
    letter-spacing: ${props => props.isMobile ? '3px' : '5px'};
    font-weight: 300;
    margin: 0;
    text-transform: uppercase;
`

const MoonriseIntro = ({ onComplete }) => {
    const { isMobile } = useResponsive()

    useEffect(() => {
        const timer = setTimeout(() => {
            onComplete()
        }, isMobile ? 2400 : 2800)

        return () => clearTimeout(timer)
    }, [onComplete, isMobile])

    return (
        <IntroContainer
            initial={{ opacity: 1 }}
            exit={{
                opacity: 0,
                transition: { duration: 0.5, ease: [0.4, 0, 0.2, 1] }
            }}
        >
            <ContentWrapper isMobile={isMobile}>
                <LogoMark
                    isMobile={isMobile}
                    initial={{ opacity: 0, scale: 0.8 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{
                        duration: 0.6,
                        delay: 0.2,
                        ease: [0.4, 0, 0.2, 1]
                    }}
                />

                <MainTitle
                    isMobile={isMobile}
                    initial={{ opacity: 0, y: 15 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{
                        duration: 0.6,
                        delay: 0.5,
                        ease: [0.4, 0, 0.2, 1]
                    }}
                >
                    Tsukihime
                </MainTitle>

                <Divider
                    isMobile={isMobile}
                    initial={{ opacity: 0, scaleX: 0 }}
                    animate={{ opacity: 1, scaleX: 1 }}
                    transition={{
                        duration: 0.5,
                        delay: 0.8,
                        ease: [0.4, 0, 0.2, 1]
                    }}
                />

                <Subtitle
                    isMobile={isMobile}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{
                        duration: 0.5,
                        delay: 1,
                        ease: [0.4, 0, 0.2, 1]
                    }}
                >
                    A Blue Glass Moon
                </Subtitle>
            </ContentWrapper>
        </IntroContainer>
    )
}

export default MoonriseIntro